import React, {useMemo} from 'react';
import {Collapse, Input} from 'antd';
import {useTranslation} from 'react-i18next';
import {observer} from 'mobx-react-lite';
import TrendData from './TrendData';

const {Panel} = Collapse;

const TREND_GROUPS = {
    1: '1 группа. Нестабильная работа, в том числе из-за повышенного газосодержания.',
    2: '2 группа. Снижение дебита, в том числе из-за увеличения ГФ.',
    3: '3 группа. Снижение или увеличение дебита из-за изменения Pпл и(или) PI.',
    4: '4 группа. Нестабильный режим работы УЭЦН, в том числе из-за мехпримесей и/или солеотложений на рабочих органах УЭЦН.',
    5: '5 группа. Снижение дебита, в том числе из-за мехпримесей и/или солеотложений на приеме УЭЦН.',
    6: '6 группа. Рост температуры ПЭД, в том числе из-за солеотложений на корпусе ПЭД.',
    7: '7 группа. Снижение дебита, в том числе из-за парафина.',
    8: '8 группа. Снижение дебита из-за негерметичности.',
    9: '9 группа. Отклонения на уровне ФА скважины.',
};

const TrendWells = observer(({
                                 handleSearch,
                                 wellsData,
                                 warningData,
                             }) => {
    const {t} = useTranslation();

    const sortedWarningData = useMemo(() => {
        return warningData ? [...warningData].sort((a, b) => a.trendGroupName - b.trendGroupName) : [];
    }, [warningData]);

    return (
        <div>
            <Input
                addonBefore={t('search', 'Поиск')}
                onChange={(e) => handleSearch(e.target.value)}
                style={{paddingBottom: '20px'}}
                placeholder={t('searchPlaceholder', 'Введите для поиска...')}
            />

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'start',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    height: '400px',
                    flexDirection: 'column',
                }}
            >
                {wellsData.map((well, index) => (
                    <Collapse key={`well-collapse-${index}`} accordion ghost>
                        <Panel
                            key={`well-panel-${index}`}
                            style={{
                                display: 'flex',
                                textAlign: 'left',
                                flexDirection: 'column',
                            }}
                            header={well?.name || `Скважина ${index + 1}`}
                        >
                            {[...(sortedWarningData[index]?.trendIndividualSettings || [])]
                                .sort((a, b) => a.trendGroupName - b.trendGroupName)
                                .map((item, index) => (
                                    <Collapse key={"parameter-collapse" + index} accordion ghost>
                                        <Panel key={"parameter-panel" + index}
                                               style={{
                                                   display: 'flex',
                                                   textAlign: 'left',
                                                   flexDirection: 'column',
                                               }}
                                               header={TREND_GROUPS[item.trendGroupName] || `Группа ${item.trendGroupName}`}
                                        >
                                            <TrendData
                                                warningData={item}
                                                warningId={wellsData}
                                            />
                                        </Panel>
                                    </Collapse>))}
                        </Panel>
                    </Collapse>
                ))}
            </div>
        </div>
    );
});

export default TrendWells;